// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fwp4l","name":"styles_name__2Re3v","phone":"styles_phone__3vQL2"};